import React, { useState } from 'react';
import './PrivacyNotice.css';
import Navbar from '../components/Navbar';
import TopInfoBar from '../components/TopInfoBar';
import BookingSidebar from '../components/BookingSidebar';
import Footer from '../components/Footer';

function PrivacyNotice() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  const handleOpenBooking = () => setIsBookingOpen(true);
  const handleCloseBooking = () => setIsBookingOpen(false);

  return (
    <div className="privacy-notice-page">
      <TopInfoBar />
      <Navbar onBookNowClick={handleOpenBooking} />
      <section className="privacy-notice-section">
        <div className="privacy-notice-container">
          <div className="privacy-notice-content">
            <h1 className="privacy-notice-title">Privacy Notice</h1>
            <p className="privacy-notice-intro">
              Hacienda Del Sol Resort ("we," "our," or "us") values your privacy and is committed to protecting your personal information. This Privacy Notice explains what information we collect, how we use it, and your rights.
            </p>

            <div className="privacy-section">
              <h2 className="privacy-section-title">1. Information We Collect</h2>
              <p className="privacy-section-text">
                When you fill out our quote request form, we may collect:
              </p>
              <ul className="privacy-list">
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Event details (e.g., date, number of guests, event type)</li>
                <li>Any additional information you voluntarily provide</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">2. How We Use Your Information</h2>
              <p className="privacy-section-text">
                We use the information you provide to:
              </p>
              <ul className="privacy-list">
                <li>Respond to your quote requests</li>
                <li>Provide relevant information about our services</li>
                <li>Improve our website and customer experience</li>
              </ul>
              <p className="privacy-section-text">
                We will not sell or rent your personal information to third parties.
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">3. How We Store Your Information</h2>
              <p className="privacy-section-text">
                Your information is stored securely and only accessible to authorized Hacienda Del Sol Resort staff. We retain your data only as long as necessary to respond to your request or as required by law.
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">4. Sharing Your Information</h2>
              <p className="privacy-section-text">
                We may share your information with trusted third-party service providers who assist us in delivering our services (e.g., booking systems or email communication tools). All third parties are obligated to keep your information secure.
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">5. Your Rights</h2>
              <p className="privacy-section-text">
                You have the right to:
              </p>
              <ul className="privacy-list">
                <li>Access, correct, or delete your personal information</li>
                <li>Opt out of marketing communications</li>
              </ul>
              <p className="privacy-section-text">
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">6. Cookies and Analytics</h2>
              <p className="privacy-section-text">
                Our website may use cookies or similar tracking technologies to improve your browsing experience. You can adjust your browser settings to refuse cookies, but some features may not function properly.
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">7. Changes to This Privacy Notice</h2>
              <p className="privacy-section-text">
                We may update this Privacy Notice from time to time. The updated version will be posted on our website with the revision date.
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">8. Contact Us</h2>
              <p className="privacy-section-text">
                If you have questions or concerns about your privacy, please contact us:
              </p>
              <ul className="privacy-list">
                <li>Phone: [956] 459-9800</li>
              </ul>
            </div>

            <div className="privacy-section">
              <p className="privacy-effective-date">
                Effective Date: [01/08/2026]
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer onBookNowClick={handleOpenBooking} />
      <BookingSidebar isOpen={isBookingOpen} onClose={handleCloseBooking} />
    </div>
  );
}

export default PrivacyNotice;
